module.exports = __webpack_public_path__ + "img/tui.80530259.png";